/**
 * The settings categories, in the order of web.md §4 and design fix 1:
 * Sources · Topics · Folders · Tags · Filters · Models · MCPs · Theme · Account.
 * Tags uses the `tag` icon; Topics uses `target`.
 *
 * Each category module owns its list and editor (Wave 2 replaces the placeholders); this file only
 * fixes the order. `registerSettingsCategory` adds a category at runtime (tests and harnesses only).
 */

import { category as account } from './account/index.js';
import { category as filters } from './filters/index.js';
import { category as folders } from './folders/index.js';
import { category as mcps } from './mcps/index.js';
import { category as models } from './models/index.js';
import type { SettingsCategory } from './shell/types.js';
import { category as sources } from './sources/index.js';
import { category as tags } from './tags/index.js';
import { category as theme } from './theme/index.js';
import { category as topics } from './topics/index.js';

export const SETTINGS_CATEGORIES: readonly SettingsCategory[] = [sources, topics, folders, tags, filters, models, mcps, theme, account];

const extra: SettingsCategory[] = [];

export function registerSettingsCategory(category: SettingsCategory): void {
  if (!extra.some((c) => c.id === category.id)) extra.push(category);
}

export function settingsCategories(): readonly SettingsCategory[] {
  return extra.length ? [...SETTINGS_CATEGORIES, ...extra] : SETTINGS_CATEGORIES;
}

export function findCategory(id: string | undefined): SettingsCategory | undefined {
  return settingsCategories().find((c) => c.id === id);
}
